module.exports = __webpack_public_path__ + "img/ic_12_ranking_equal.03327372.svg";